import type { Host, Region } from '../types/common';

interface StringMap {
  [key: string]: string;
}

interface IGETReqObj {
  url: string;
  headers?: StringMap;
}

interface IPOSTReqObj extends IGETReqObj {
  data?: Object;
}

export interface IGenerateTokenAPIResult {
  error?: null | Object;
  data?: {
    data: {
      token: string;
    };
    error: {
      message: string;
      devMessage: string;
      source: 'chat-api' | Omit<string, 'chat-api'>;
      code: 'AUTH_ERR_AUTH_TOKEN_NOT_FOUND' | string;
    };
  };
}

export interface IVerifyTokenAPIResult {
  error?: null | Object;
  data?: {
    data?: {
      callToken: string;
      settings: {
        PRESENTER_MODE_ENABLED: boolean;
        WEBRTC_HOST: Host;
        ANALYTICS_HOST: string;
        ANALYTICS_VERSION: string;
      };
      payload: {
        data: {
          appId: string;
          region: Region;
          authToken: string;
          user: {
            uid: string;
            name: string;
            avatar: string;
          };
          sessionId: string;
          passthrough: any;
        };
        room: string;
      };
    };
    error?: {
      message: string;
      devMessage: string;
      source: 'chat-api' | Omit<string, 'chat-api'>;
      // TODO: Get error codes from sachin
      code: 'AUTH_ERR_AUTH_TOKEN_NOT_FOUND' | string;
    };
  };
}

export const postAPI = (
  postReqObj: IPOSTReqObj,
): Promise<IGenerateTokenAPIResult> => {
  return new Promise(resolve => {
    const apiHeaders = new Headers();
    apiHeaders.append('content-Type', 'application/json');
    apiHeaders.append('Accept', 'application/json');
    if (typeof postReqObj.headers === 'object') {
      for (const key in postReqObj.headers) {
        apiHeaders.append(key, postReqObj.headers[key]);
      }
    }

    const requestOptions = {
      method: 'POST',
      headers: apiHeaders,
      body: JSON.stringify(postReqObj.data),
    };

    fetch(postReqObj.url, requestOptions)
      .then(response => response.json())
      .then(res => {
        resolve({
          error: null,
          data: res,
        });
      })
      .catch(error => {
        console.log(error);
        resolve({
          error: error,
          data: undefined,
        });
      });
  });
};

export const getAPI = (
  getReqObj: IGETReqObj,
): Promise<IVerifyTokenAPIResult> => {
  return new Promise(resolve => {
    const apiHeaders = new Headers();
    apiHeaders.append('Accept', 'application/json');
    if (typeof getReqObj.headers === 'object') {
      for (const key in getReqObj.headers) {
        apiHeaders.append(key, getReqObj.headers[key]);
      }
    }

    const requestOptions = {
      method: 'GET',
      headers: apiHeaders,
    };

    fetch(getReqObj.url, requestOptions)
      .then(response => response.json())
      .then(res => {
        resolve({
          error: null,
          data: res,
        });
      })
      .catch(error => {
        console.log(error);
        resolve({
          error: error,
          data: undefined,
        });
      });
  });
};

/**
 * Encodes the given data object into a query string.
 * @param data - The data object to be encoded.
 * @returns The encoded query string.
 */
export function encodeQueryData(data: any) {
  const ret = [];
  for (let d in data)
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  return ret.join('&');
}
